import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/about-us")({
  // Legacy alias — permanently redirect to the canonical /about.
  beforeLoad: () => {
    throw redirect({ to: "/about", replace: true, statusCode: 301 });
  },
  head: () => ({
    meta: [{ name: "robots", content: "noindex" }],
    links: [
      { rel: "canonical", href: "https://precisionpaverspools.com/about" },
    ],
  }),
});
